import FeedLayout from "layouts/files/FeedLayout";
import { Link } from "react-router-dom";
import { SVG, SettingsItem } from "ui";

const Prefrence = () => {
    return (
        <FeedLayout pageTitle="Settings">
            <div className="settings-page">
                <div className="d-flex flex-j-between flex-a-center gap-10 w-full text-center mb-30 mt-20">
                    <Link to="/settings">
                        <SVG svg="chevron-left" size={24} />
                    </Link>
                    <h1 className="fw-700 fs-12em">Prefrences</h1>
                    <div></div>
                </div>
                <div className="card pl-10 pr-10 pt-10 pb-10">
                    {/* account info */}
                    <SettingsItem
                        svg="slash"
                        title="Block Users"
                        details="Block user list."
                        link="/settings/prefrence/block"
                    />
                    {/* change pswd */}
                    <SettingsItem
                        svg="volume-x"
                        title="Mute Users"
                        details="Mute user list"
                        link="/settings/prefrence/mute"
                        className="mb-20"
                    />
                </div>
            </div>
        </FeedLayout>
    );
};

export default Prefrence;
